import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "72",
  height: "72",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "72",
      height: "72",
      fill: "#1A9FCC",
      rx: "36"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M29.766 50.172h12.468q1.235 0 1.938-.703.719-.688.719-1.985v-.28q0-1.377-.625-2.735a14 14 0 0 0-1.532-2.625 23 23 0 0 0-1.89-2.266 79 79 0 0 0-1.672-1.734q-.75-.766-.734-1.563.015-.812.734-1.515.703-.704 1.672-1.72a26 26 0 0 0 1.89-2.265 14 14 0 0 0 1.532-2.61q.624-1.374.625-2.765v-.234q0-1.297-.72-1.985-.702-.703-1.937-.703H29.766q-1.235 0-1.953.703-.72.688-.72 1.985v.234q0 1.391.61 2.766.625 1.359 1.547 2.61.937 1.233 1.906 2.265.969 1.015 1.657 1.719.718.703.734 1.515.03.797-.734 1.563-.687.703-1.657 1.734a25 25 0 0 0-1.906 2.266 14.6 14.6 0 0 0-1.547 2.625q-.61 1.359-.61 2.734v.281q0 1.297.72 1.985.718.703 1.953.703m1.28-2.438q-.498 0-.64-.468-.125-.453.235-.782l4.422-4.265q.187-.204.25-.328.078-.126.078-.422v-6.157q0-.562-.157-.921-.14-.36-.547-.72-.687-.608-1.562-1.405a31 31 0 0 1-1.531-1.485q-.313-.327-.188-.672.126-.343.547-.343h8.094q.421 0 .547.343.124.344-.203.672-.641.688-1.516 1.485-.874.796-1.563 1.406-.42.36-.562.719-.14.36-.14.922v6.156q0 .297.062.422.063.124.266.328l4.421 4.265q.344.33.22.782-.126.468-.642.468z"
    }, null, -1)
  ])))
}
export default { render: render }